import throwAsync from './throwAsync';

/**
 * Convert the standardized date format into the equivalent moment date format.
 * @param dateformat - The standardized date format.
 */
export default function dateformat_to_moment(dateformat: string): string {
    // Recognized components are 'yyyy', 'mm' and 'dd'. After stripping them, only separators should remain.
    // If not, the format is invalid.
    const stripped = dateformat.replaceAll('yyyy', '').replaceAll('mm', '').replaceAll('dd', '');
    if (/[^./\- ]/.test(stripped)) {
        throwAsync(new Error(`Invalid date format: ${dateformat}`));
        return 'YYYY-MM-DD';
    }

    return dateformat.toUpperCase();
}
